// Help page head values, defined once. (#1143)
//
// Two consumers must agree exactly: HelpArticlePage/HelpTopicPage write these through
// Helmet, and scripts/prerender-meta.js writes them into each page's static HTML.
// Google may use either the raw or the rendered canonical and title, so a difference
// between them is a defect. CommonJS for the same reason as socialTags.js.

const { SITE } = require('./socialTags');

const articlePath = (slug) => `/help/article/${slug}`;
const topicPath = (slug) => `/help/topic/${slug}`;

/** The canonical URLs: the one site origin (socialTags.js) plus the path. */
const articleUrl = (slug) => `${SITE}${articlePath(slug)}`;
const topicUrl = (slug) => `${SITE}${topicPath(slug)}`;

const articleTitle = (article) => `${article.title} | Chaptery Help`;
const topicTitle = (topic) => `${topic.title} | Chaptery Help Center`;

/**
 * The lead as plain text for a search snippet or link preview: inline markdown removed
 * ([text](url) keeps its text, ** and backticks go), then cut at a word to ~155 characters.
 */
function articleDescription(article) {
  const lead = (article.lead || '')
    .replace(/\[([^\]]*)\]\([^\s)]*\)/g, '$1')
    .replace(/\*\*/g, '')
    .replace(/`/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!lead) {
    return article.topic
      ? `${article.title}: a Chaptery help article on ${article.topic}.`
      : `${article.title}: a Chaptery help article.`;
  }
  if (lead.length <= 155) return lead;
  // The last space at or before 152; a lead with no space there is cut hard.
  const space = lead.slice(0, 153).lastIndexOf(' ');
  return `${lead.slice(0, space > 0 ? space : 152).trimEnd()}…`;
}

module.exports = { articlePath, topicPath, articleUrl, topicUrl, articleTitle, topicTitle, articleDescription };
